import { format, parseISO } from "date-fns";

const convertISODateToDayMonthYear = (date) => {
  return format(parseISO(date), "dd/MM/yyyy");
};

export { convertISODateToDayMonthYear };
